module.exports = __webpack_public_path__ + "img/20190701155922666.2b68d67b.png";